export interface GameplaySeedSource {
  setSeed(seed: string): void;
}

export interface GameplaySeedEntry {
  readonly normalSeed: string;
  readonly source: GameplaySeedSource;
}

const validateSeed = (seed: string): void => {
  if (seed.length === 0) {
    throw new RangeError("Gameplay seed is required");
  }
};

export class GameplaySeedRuntime {
  private readonly entries: {
    normalSeed: string;
    readonly source: GameplaySeedSource;
  }[];

  public constructor(entries: readonly GameplaySeedEntry[]) {
    if (entries.length === 0) {
      throw new RangeError("At least one gameplay seed source is required");
    }
    this.entries = entries.map((entry) => ({ ...entry }));
  }

  public setNormalSeed(seed: string): void {
    validateSeed(seed);
    for (const entry of this.entries) {
      entry.normalSeed = seed;
      entry.source.setSeed(seed);
    }
  }

  public useChallenge(seed: string): void {
    validateSeed(seed);
    for (const entry of this.entries) {
      entry.source.setSeed(seed);
    }
  }

  public useNormal(): void {
    for (const entry of this.entries) {
      entry.source.setSeed(entry.normalSeed);
    }
  }
}
